import { GetterTree } from 'vuex';
import { MypageState } from '@/store/mypage/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters : GetterTree<MypageState, RootState> = {
  findInformationById: (state: MypageState) => (notificationId: string) => {
    return _.find(state.informations, { notificationId })
  },
};

export default getters;
